/* eslint-disable */
import React from 'react';
import { Typography } from 'antd';
import userAuthManager, { AUTH_FLOW_KEY } from 'utils/flowGate';
import { SignoutCallbackComponent } from 'redux-oidc';
import sessionStorageUtils from 'utils/sessionStorageUtils';

const LogoutRedirect = () => {
  const successCallback = () => {
    sessionStorageUtils.remove(AUTH_FLOW_KEY);
    userAuthManager.signinRedirect();
  };

  const errorCallback = error => {
    console.error(error);
    sessionStorageUtils.remove(AUTH_FLOW_KEY);
    userAuthManager.removeUser();
  };

  return (
    <SignoutCallbackComponent
      userManager={userAuthManager}
      successCallback={successCallback}
      errorCallback={errorCallback}
    >
      <Typography.Title level={2} style={{ textAlign: 'center', marginTop: 30 }}>
        Thank you for your patience.
      </Typography.Title>
    </SignoutCallbackComponent>
  );
};

export default LogoutRedirect;
